import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Footer from './Footer';
import CoachFooter from './CoachFooter';
import './AppLayout.css';

// Couleur d'identité par domaine (source de vérité : constants/colors.js,
// injectée au démarrage). La page courante et la barre de navigation héritent
// de --color-primary, ce qui donne un thème par page (nav active, boutons,
// titres, accents prennent la couleur du domaine).
const ROUTE_ACCENT = {
  '/cycle':  'var(--phase-ovulation)', // ambre  — PHASE.ovulation
  '/mental': 'var(--mental-primary)',  // rose   — MENTAL.primary
  '/sport':  'var(--sport-primary)',   // bleu   — SPORT.primary
};

// La section coach n'avait aucune identité de couleur : elle retombait sur le
// défaut, et Coach.js compensait en codant les teintes en dur dans ses styles
// inline. Le préfixe couvre le dashboard, les fiches sportives et les équipes.
const COACH_ACCENT = 'var(--sport-primary)';

const AppLayout = () => {
  const { user } = useAuth();
  const isCoach = user?.role === 'coach';
  const { pathname } = useLocation();

  const accent = pathname.startsWith('/coach') ? COACH_ACCENT : ROUTE_ACCENT[pathname];
  const themeStyle = accent ? { '--color-primary': accent } : undefined;

  return (
    <div className="app-layout" style={themeStyle}>
      <div className="app-layout__content">
        <Outlet />
      </div>
      {isCoach ? <CoachFooter /> : <Footer />}
    </div>
  );
};

export default AppLayout;
